<p-dialog class="user-admin-dialog" [(visible)]="isOpen" [modal]="true" [responsive]="true" [maximizable]="false" [appendTo]="'body'" [styleClass]="'contextMenuModal profileModal'"
  [closable]="false" [dismissableMask]="true" [baseZIndex]="10000" [closeOnEscape]="true" [style]="{'height':'740px','max-width':'1350px', 'width': '70%'}"
  [resizable]="false">
  <p-header>
    <div class="d-flex flex-row align-items-center justify-content-between  mx-2 mt-1">
      <h6 class="reage-title">User Admin</h6>
      <button type="button" (click)="closeModal()" class="d-flex flex-row closebtn">
        <img src="assets/qwyn/icons/close-white.svg" alt="Close">
      </button>
    </div>
  </p-header>
  <div class="gfid-body admin-gfid-padding">
    <ng-template #customLoadingTemplate>
      <div class="custom-class-loader">
        <div class="spinner-container">
          <img src="assets/qwyn/icons/spinner.gif" alt="Loading" class="loader">
        </div>
      </div>
    </ng-template>
    <ngx-loading [show]="showSpinner" [config]="{ backdropBorderRadius: '3px' }" [template]="customLoadingTemplate">
    </ngx-loading>
    <div class="w-70">
      <p-tabView class="adminview no-header" id='profileTabs'  #profileTabs (onChange)="onTabChange($event)" [styleClass]="'user-admin-tabview no-header'" [scrollable]="false"
        [style]="{'height':'595px','width':'95%','max-width':'1200px',overflow: 'hidden', 'position': 'relative'}"
        [activeIndex]="actTabIdx">
        <p-tabPanel [header]="''" class="">
          <div class="pe-2 pt-4 mt-1">
            <div class="row p-2">
              <div class="col-3 flex align-items-center align-center">
                <label for="from" class="label_font">Search by User ID </label>
              </div>
              <div class="col-9">
                <div class="w-100">
                  <div class="d-flex justify-content-start">
                    <input type="text" [(ngModel)]="newUserSoeid" #soeId [ngModelOptions]="{standalone: true}" 
                      placeholder="Search..." class="w-50 search-box" (keydown)="keyDownFunction($event)" />
                    <img src="assets/qwyn/icons/search-icon-new.svg" alt="Search" class="search-icon" (click)="keyDownFunction($event)" />
                  </div>
                  <!-- assets/mobile/search.svg -->
                  <span *ngIf="userNotMatch"
                         style="color: red; font-size: 14px; padding-top:10px; font-style: italic">{{validationError}}</span>
                   <span *ngIf="newUserSoeIdValidationFlag"
                        style="color: red;font-size: 14px;padding-top:10px; font-style: italic">{{blankStringValidationMsg}}
                  </span> 
                </div>
              </div>
              
              <!-- <div class="col-9">
                <input type="text" [(ngModel)]="newUserSoeid" #soeId [ngModelOptions]="{standalone: true}" (keydown)="keyDownFunction($event)"
                  placeholder="Search..." class="w-50 search-box" />
                <em class="search-icon fa fa-search" (click)="keyDownFunction($event)"></em>
                <div *ngIf="userNotMatch" class="alert alert-danger w-50" role="alert">
                  {{validationError}}
                </div>
                <div *ngIf="newUserSoeIdValidationFlag" class="alert alert-danger w-50" role="alert">
                  {{blankStringValidationMsg}}
                </div>
              </div> -->
              
            </div>
            <div *ngIf="userDetails || userNotFound">
              <div class="row p-2">
                <div class="col-3">
                  <label class="flex-grow label_font">Name:</label>
                </div>
                <div class="col-9">
                  <span *ngIf="userNotFound; else elseBlock1">
                    <input type="text" #name="ngModel" [(ngModel)]="userDetails.userName" required
                      [ngModelOptions]="{standalone: true}" placeholder="Enter Username" class="w-50 search-box" />
                      <div *ngIf="userNotExist" class="alert alert-danger w-50" role="alert">
                        {{validationError}}
                      </div>
                  </span>
                  <ng-template #elseBlock1>
                    <label class="flex-grow label_font">{{userDetails.userName}}</label>
                  </ng-template>
                </div>
              </div>
              <div class="row p-2">
                <div class="col-3">
                  <label class="flex-grow label_font">Email:</label>
                </div>
                <div class="col-9">
                  <span *ngIf="userNotFound; else elseBlock2">
                    <input type="text" #email="ngModel" [(ngModel)]="userDetails.email" required
                      [ngModelOptions]="{standalone: true}" placeholder="Enter Email" class="w-50 search-box" />
                      <div *ngIf="notValidEmail" class="alert alert-danger w-50" role="alert">
                        {{validationError}}
                      </div>
                  </span>
                  <ng-template #elseBlock2>
                    <label class="flex-grow label_font">{{userDetails.email}}</label></ng-template>
                </div>
              </div>
              <div class="row p-2">
                <div class="col-3">
                  <label class="flex-grow label_font">Active:</label>
                </div>
                <div class="col-9">
                  <span *ngIf="userNotFound; else elseBlock3">
                    <p-inputSwitch [(ngModel)]="userDetails.active" [ngModelOptions]="{standalone: true}"
                      [styleClass]="'advance-inputSwitch'">
                    </p-inputSwitch>
                  </span>
                  <ng-template #elseBlock3>
                    <p-inputSwitch [(ngModel)]="userDetails.active" [ngModelOptions]="{standalone: true}" [styleClass]="'advance-inputSwitch'" [disabled]="userNotFound">
                    </p-inputSwitch>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="userDetails" class="p-2 admin-checklist">
            <p-pickList [source]="availableAdminRoles" [target]="selectedAdminRoles" sourceHeader="Available Admin Roles" targetHeader="Assigned Admin Roles"
              [responsive]="true" dragdrop="true" [showSourceControls]="false" [showTargetControls]="false">
              <ng-template let-item pTemplate="item">
                <div class="ui-helper-clearfix">
                  <span>{{item.role}}</span>
                </div>
              </ng-template>
            </p-pickList>
          </div>
        </p-tabPanel>
        <p-footer class="fix-footer">
          <div class="d-flex flex-row flex-wrap px-3 pb-2 pt-3 justify-content-end">
            <button class="btn  me-4 cancel-btn" (click)="reset()">Reset</button>
            <button type="submit" class="btn  submmit-btn" (click)="saveChanges()">Submit</button>
          </div>
        </p-footer>
      </p-tabView>
    </div>
  </div>
  <p-toast></p-toast>
</p-dialog>
<!-- for sucess message -->
<p-dialog [(visible)]="displaySuccess" [modal]="true" [responsive]="true" [maximizable]="false" [appendTo]="'body'" [styleClass]="'contextMenuModal successModal ModelClose'"
  [closable]="true" [dismissableMask]="true" [baseZIndex]="10000" [closeOnEscape]="true" [style]="{width: '30%'}">
  <p-header>
    <div class="d-flex flex-row align-items-center justify-content-between">
      <h6 class="success-title">Success Confirmation</h6>
    </div>
  </p-header>
  <div class="success-msg">{{successMessage}}</div>
</p-dialog>
<!--for error message-->
<p-dialog [(visible)]="errorMessage" [modal]="true" [responsive]="true" [maximizable]="false" [appendTo]="'body'" [styleClass]="'contextMenuModal failureModal ModelClose'"
  [closable]="true" [dismissableMask]="true" [baseZIndex]="10000" [closeOnEscape]="true" [style]="{width: '30%'}">
  <p-header>
    <div class="d-flex flex-row align-items-center justify-content-between">
      <h6 class="success-title">Information</h6>
    </div>
  </p-header>
  <div class="success-msg">{{errorMessage}}</div>
</p-dialog>